import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { acceptInviteAPI, verifyTokenApi } from "../_request";
import { useAuth } from "context";
import CircularProgress from "@mui/material/CircularProgress";
import "../../style.css";

function AcceptInvite() {
  const tokenCode = new URL(window.location.href).searchParams.get("token") || null;
  const { saveAuthData, showSnackbarWithMessage } = useAuth();
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(undefined);
  const [storeStatus, setstoreStatus] = useState();
  const navigate = useNavigate();
  const [count, setCount] = useState(10);
  const [countVisible, setCountVisible] = useState(true);
  const [isApiSuccess, setIsApiSuccess] = useState(false);
  const handleAcceptInvite = async () => {
    const {
      data: { success, data, message },
    } = await acceptInviteAPI({ token: tokenCode });
    if (success) {
      const authData = data.tokens;
      await saveAuthData(authData);
      const verifyResponse = await verifyTokenApi({ accessToken: authData.accessToken });
      const { success: verifySuccess, data: verifyData } = verifyResponse.data;
      if (verifySuccess && verifyData.verifiedData.verifiedAt) {
        setLoader(false);
        setIsApiSuccess(true);
        return;
      } else if (verifySuccess) {
        setLoader(false);
        navigate("/authentication/verify-customer");
        showSnackbarWithMessage({
          type: "success",
          message: "You're in! To complete the process, please verify your email.",
        });
        return;
      } else {
        setLoader(false);
        setError(message);
        showSnackbarWithMessage({
          type: "error",
          message: "something went wrong",
        });
      }
    } else {
      if (data && data?.tokens) {
        const authData = data.tokens;
        await saveAuthData(authData);
      }
      setstoreStatus(message);
      showSnackbarWithMessage({
        type: "error",
        message,
      });
      setError(message);
      setLoader(false);
    }
  };

  useEffect(() => {
    handleAcceptInvite();
  }, []);

  useEffect(() => {
    if (isApiSuccess) {
      const intervalId = setInterval(() => {
        setCountVisible(false);
        setTimeout(() => {
          setCount((prevCount) => prevCount - 1);
          setCountVisible(true);
        }, 500);
      }, 1000);

      if (count === 0) {
        clearInterval(intervalId);
        navigate("/dashboard");
        showSnackbarWithMessage({
          type: "success",
          message: "Login successful. Welcome to the Catering Rewards!",
        });
      }

      return () => clearInterval(intervalId);
    }
  }, [isApiSuccess, count, navigate, showSnackbarWithMessage]);
  return (
    <MDBox
      width={"100%"}
      height="100%"
      minHeight="100vh"
      sx={{ overflowX: "hidden", display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      {loader && <CircularProgress color="success" />}
      {storeStatus === "Invite Accepted" && !loader ? (
        <MDBox sx={{ textAlign: "center", padding: "20px" }}>
          <h2>Invite has already been accepted</h2>
          <p>
            You can reset your password for security using the temporary password sent to your
            email.
          </p>
          <p>Please check your spam folder if you don&apos;t see our email.</p>
          <p>
            <MDTypography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Click here
            </MDTypography>{" "}
            to proceed.
          </p>
        </MDBox>
      ) : storeStatus === "Invite Expired" && !loader ? (
        <MDBox sx={{ textAlign: "center", padding: "20px" }}>
          <h2>Invite link has expired</h2>
          <p>
            Don&apos;t worry, it seems the invite link has expired. Please ask the restaurant to
            resend the invite request.
          </p>
        </MDBox>
      ) : storeStatus === "Thanks! You've already joined using this invite" && !loader ? (
        <MDBox sx={{ textAlign: "center", padding: "20px" }}>
          <h2>Thanks! You&apos;ve already joined using this invite.</h2>
          <p>
            <MDTypography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
              sx={{ fontSize: "20px" }}
            >
              Click here
            </MDTypography>{" "}
            to login in portal
          </p>
        </MDBox>
      ) : error && !loader ? (
        <MDBox sx={{ textAlign: "center", padding: "20px" }}>
          <h2>Whoops! We couldn&apos;t find the invite request.</h2>
          <p>{error}</p>
        </MDBox>
      ) : (
        ""
      )}
      {!error && !loader && (
        <MDBox sx={{ textAlign: "center", padding: "20px" }}>
          <h2>Welcome to Our Catering Rewards Program!</h2>
          <p>
            Your account setup is underway. You&apos;ll be redirected to your dashboard shortly.
            <br></br>
          </p>
          <br></br>
          <h4>Enjoy your rewards journey!</h4>
          <p>
            The page will redirect in{" "}
            <span className={`countdown ${countVisible ? "visible" : ""}`}>{count}</span> seconds.
            If not,{" "}
            <MDTypography
              component={Link}
              to="/dashboard"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Click here
            </MDTypography>{" "}
            to reset your password.
          </p>
        </MDBox>
      )}
    </MDBox>
  );
}
export default AcceptInvite;
